<template>
    <chart :chartData="timelineChartData"/>
</template>

<script>
import Chart from './Chart.vue';

export default {    
    props: {
        chartData: {},
        showParliaments: {
            default: true
        }
    },
    components: {
        Chart
    },
    computed: {
        timelineChartData() {
            const plotLines = this.showParliaments ? this.$store.getters.GET_PARLIAMENTS_ORDERED
                .map(p => ({
                    value: (new Date(p.DateElection)).valueOf(),
                    dashStyle: 'shortdash',
                    color: '#CCD6EB',
                    label: {
                        text: p.PID
                    }})) : [];

            return {
                tooltip: {
                    formatter: function () {
                        const endDate = this.point.present ? 'present' : new Date(this.x2).toLocaleDateString();
                        return this.point.party ? 
                        `<div>${this.point.name} (${this.point.party}) - ${new Date(this.x).toLocaleDateString()} - ${endDate}</div>`
                        :
                        `<div>${this.point.name} - ${new Date(this.x).toLocaleDateString()} - ${endDate}</div>`
                    },
                    positioner: function(labelWidth, labelHeight, point) {
                        return {
                            x: Math.min(point.plotX - (labelWidth / 2) + 60, this.chart.chartWidth - labelWidth - 10),
                            y: point.plotY - this.chart.hoverPoint.shapeArgs.width,
                        };
                    },                        
                    backgroundColor: 'rgba(255, 255, 255, 0)',
                    shadow: false,
                    borderWidth: 0,
                    borderRadius: 0,
                    useHTML: true,
                },
                title: {
                    text: ''
                },
                accessibility: {
                    point: {
                        descriptionFormatter: function (point) {
                            var ix = point.index + 1,
                                category = point.yCategory,
                                from = new Date(point.x),
                                to = new Date(point.x2);
                            return ix + '. ' + category + ', ' + from.toDateString() +
                                ' to ' + to.toDateString() + '.';
                        }
                    }
                },
                plotOptions: {
                    series: {
                        borderWidth: 2,
                        borderColor: 'white',
                        dataLabels: {
                            align: 'left',
                            x: 30,
                            crop: false,
                            allowOverlap: true
                        }
                    }
                },
                xAxis: {
                    title: {
                        text: 'Year and Parliament number'
                    },
                    type: 'datetime',
                    reversed: false,
                    plotLines
                },
                legend: {
                    enabled: false
                },
                ...this.chartData                                       
            }
        }
    }
}
</script>
<style>
.highcharts-yaxis-grid {
    display: none;
}
</style>